import { useState } from 'react'
import BatchGenerationPanel from './BatchGenerationPanel'
import BatchJourneyBrowser from './BatchJourneyBrowser'
import BatchEvaluationLLMPanel from './BatchEvaluationLLMPanel'
import RubricEditor from './RubricEditor'

export default function BatchDashboard() {
  const [lastCompletedJob, setLastCompletedJob] = useState(null)
  const [selectedJourneyIds, setSelectedJourneyIds] = useState([])

  return (
    <div className="space-y-6">
      <BatchGenerationPanel
        onJobComplete={(job) => setLastCompletedJob(job)}
      />

      <BatchJourneyBrowser
        jobId={lastCompletedJob?.id}
        onSelectionChange={setSelectedJourneyIds}
      />

      <BatchEvaluationLLMPanel
        selectedJourneyIds={selectedJourneyIds}
      />

      <RubricEditor />
    </div>
  )
}
